import { nativeBlockIcon } from '../icons';

const singlePostWithNativeBlock = {
  name: 'single-post-with-native-block',
  title: 'Single Post with Default Post Title',
  icon: nativeBlockIcon,
  scope: ['block'],
  innerBlocks: [
    [
      'b3rg/div',
      {
        blockClassNames: [
          {
            value: `e-sgp__media`,
            label: 'e-sgp__media',
          },
        ],
        enableFocusableIcon: false,
        lockTemplate: 'false',
      },
      [['core/post-featured-image']],
    ],
    [
      'b3rg/div',
      {
        blockClassNames: [
          {
            value: `e-sgp__content`,
            label: 'e-sgp__content',
          },
        ],
        enableFocusableIcon: false,
        lockTemplate: 'false',
      },
      [
        ['core/post-title'],
        ['core/post-date'],
        ['b3rg/meta-field', { selectedMetaField: 'learn_more_label' }],
      ],
    ],
  ],
};

export default singlePostWithNativeBlock;
